import { makeAutoObservable } from 'mobx';
import { ColorEnum, IconNameEnum } from '@app/common';
import { PersonalAssetSpecialTypeEnum, PersonalAssetTypeEnum, PersonalAssetWithValueDto } from '../../../../defs/api';
import { PersonalAssetMetadataDataModel } from './personal-asset-meta-data-mobx-dto';
import { ensureIconName, ensureColorName } from '../../../../utils/ensure-enum-value';

export class PersonalAssetWithValueMobxDto implements Omit<PersonalAssetWithValueDto, 'iconName' | 'colorName'> {
    id: string;

    iconName: IconNameEnum = IconNameEnum.WalletFilled;

    colorName: ColorEnum = ColorEnum.Blue;

    type: PersonalAssetTypeEnum | null;

    sourceType: PersonalAssetSpecialTypeEnum | null;

    currencyCode: string;

    deleted: boolean;

    lastUpdated: Date;

    createdAt: Date;

    metaData?: PersonalAssetMetadataDataModel;

    name: string;

    order: number;

    portfolioId: string;

    value?: number;

    interest?: number;

    fee?: number;

    reward?: number;

    constructor() {
        makeAutoObservable(this);
    }

    static create(dto: PersonalAssetWithValueDto): PersonalAssetWithValueMobxDto {
        const mobxDto = new PersonalAssetWithValueMobxDto();
        Object.assign(mobxDto, dto, {
            metaData: dto.metaData ? PersonalAssetMetadataDataModel.create(dto.metaData) : undefined,
        });

        mobxDto.iconName = ensureIconName(dto.iconName);
        mobxDto.colorName = ensureColorName(dto.colorName);

        return mobxDto;
    }

    static createFromArray(dtos: PersonalAssetWithValueDto[]): PersonalAssetWithValueMobxDto[] {
        const createdDtos: PersonalAssetWithValueMobxDto[] = [];
        dtos.forEach((dto) => {
            createdDtos.push(PersonalAssetWithValueMobxDto.create(dto));
        });

        return createdDtos;
    }
}
